// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"9fd3d70a","577":"16fff8b1"}[chunkId] + ".chunk.css";
};